// Active Products array
import { createSelector, createSlice } from "@reduxjs/toolkit";
import setPaymentPageValuesAction from "../actions/formDataActions";
import {
    selectFormDataValuesSelector,
    selectSessionReduxDataSelector,
} from "../selectors/formDataSelectors";

export const slice = createSlice({
    name: "formData",
    initialState: {},
    reducers: {
        setPaymentPageValues: setPaymentPageValuesAction,
    },
});

export const { setPaymentPageValues } = slice.actions;

// selectors

// getFormDataValues
export const selectFormDataValues = (state) =>
    selectFormDataValuesSelector(state);

// getSessionReduxData
export const selectSessionReduxData = createSelector(
    [(state) => selectFormDataValues(state)],
    (formData) => selectSessionReduxDataSelector(formData),
);

export default slice.reducer;
